import React from 'react';
import { Typography } from '@mui/material';
import { formatPercentage, formatValue } from '../../../utils/formatters';
import { ColorDot, StyledLegendLabel } from '../Legend.styles';
import { useTableLegendRow } from './useTableLegendRow';

export const LabelCell = () => {
  const { color, label, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel noWrap variant="caption" alignItems="center" display="flex" id={`${ariaPrefix}_label`}>
      <ColorDot color={color} />
      {React.isValidElement(label) ? (
        label
      ) : (
        <Typography variant="caption" noWrap>
          {label}
        </Typography>
      )}
    </StyledLegendLabel>
  );
};

export const ValueCell = () => {
  const { value, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel
      justifySelf="end"
      noWrap
      variant="caption"
      sx={{ color: 'var(--content-base-secondary)' }}
      id={`${ariaPrefix}_value`}>
      {formatValue.format(value)}
    </StyledLegendLabel>
  );
};

export const ShareCell = () => {
  const { value, total, ariaPrefix } = useTableLegendRow();
  return (
    <StyledLegendLabel
      justifySelf="end"
      noWrap
      variant="caption"
      sx={{ color: 'var(--content-base-secondary)' }}
      id={`${ariaPrefix}_percent`}>
      {total ? formatPercentage.format(value / total) : '0'}
    </StyledLegendLabel>
  );
};

export const TableLegendCells = ({
  showLabel = true,
  showShare = true,
  showValue = true,
}: {
  showLabel?: boolean;
  showShare?: boolean;
  showValue?: boolean;
}) => (
  <>
    {showLabel && <LabelCell />}
    {showValue && <ValueCell />}
    {showShare && <ShareCell />}
  </>
);
